import { Flex, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledToolbarHeader = styled(Flex)`
  ${({ isScreenLarge }: { isScreenLarge: boolean }) =>
    isScreenLarge &&
    css`
      border-bottom: 1px solid ${token('colors.gray300')};
    `}
`;
